import { ReactRouteImpl } from "abreact/incubator/ui/app/router/ReactRouteImpl";
export const UNMOUNT_ROUTE_TEMPLATE = "/absdk/unmount";
export const UNMOUNT_ROUTE = new ReactRouteImpl(UNMOUNT_ROUTE_TEMPLATE, {});
export function registerRoute(routeRegistry) {
  return routeRegistry.registerRoute({
    routeTemplate: UNMOUNT_ROUTE_TEMPLATE,
    routeTitle: "Unmount Route",
    view: {
      modulePath: () => import(/* webpackChunkName: "Builtin_Routes" */"abreact/incubator/ui/app/routes/UnmountView"),
      exportName: "UnmountView"
    }
  });
}
//# sourceMappingURL=UnmountRoute.js.map
